// Skills Hub open/closed switch.
//
// CommonJS rather than TypeScript so next.config.js and next-sitemap.config.js
// can read the same value as the pages. It is a constant in the code, not a
// Vercel environment variable, so changing it is a commit, a push and a
// Promote, and needs no access to the Production environment settings.
//
// SKILLS_HUB_OPEN
//   true:  /skills-hub lists the bookable classes; category and class pages
//          build; the Skills Hub and Course JSON-LD is emitted.
//   false: /skills-hub shows the closure notice, every /skills-hub/* URL
//          redirects to it (temporary, so reopening takes effect at once),
//          and no category or class page builds. Use this when a closure is
//          long term. A week with no classes is not a closure: the open page
//          already handles that with its "no classes open" banner.
//
// INLINE_SINGLE_CATEGORY
//   With exactly one bookable category, true lists its classes directly on
//   /skills-hub instead of a grid with a single tile. Set false to always show
//   the grid. Only matters while SKILLS_HUB_OPEN is true.
module.exports = {
  SKILLS_HUB_OPEN: true,
  INLINE_SINGLE_CATEGORY: true,
};
